// removed by extract-text-webpack-plugin
module.exports = {"RowOne":"_pyzS_","RowTwo":"_3x8CR","RatingBox":"__E0u2","RatingDots":"_2X82B","RatingBar":"_3M9uH","RatingType":"_3EEBl","RatingNumber":"_qLtoe","ReviewImage":"_3fDI9","Divider":"_2yDBu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelReview/HotelReview.scss
// module id = 919
// module chunks = 0